import { render, staticRenderFns } from "./SimpleBaseTransactionBlock.vue?vue&type=template&id=acab7e12&scoped=true"
import script from "./SimpleBaseTransactionBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleBaseTransactionBlock.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acab7e12",
  null
  
)

export default component.exports